/**
 * Created by m.igrachev on 7/24/2017.
 */
const RESPONSIVE_BREAKPOINTS = {
    verySmall: 0,
    small: 480,
    middle: 768,
    large: 1024,
    veryLarge: 1366
};

export default function(window) {
    let responsiveMode;
    let currentWidth = window.innerWidth;

    if (currentWidth >= RESPONSIVE_BREAKPOINTS.veryLarge) {
        responsiveMode = "veryLarge";
    } else if (currentWidth >= RESPONSIVE_BREAKPOINTS.large) {
        responsiveMode = "large";
    } else if (currentWidth >= RESPONSIVE_BREAKPOINTS.middle) {
        responsiveMode = "middle";
    } else if (currentWidth >= RESPONSIVE_BREAKPOINTS.small) {
        responsiveMode = "small";
    } else {
        responsiveMode = "verySmall";
    }
    return responsiveMode;
}
